import React from 'react';
import NoticeComponentVM from './NoticeComponentVM';
import { observer } from 'mobx-react';
import { Neo, NeoGrid } from "@singularsystems/neo-react";
import { ActionType } from "../../../Models/InvestorInvestments/Commands/ActionNoticeRequest";
import { DateUtils } from "@singularsystems/neo-core";

interface INoticeComponentProps {
    viewModel: NoticeComponentVM;
}

@observer
export default class NoticeComponent extends React.Component<INoticeComponentProps> {

    constructor(props: INoticeComponentProps) {
        super(props);
    }

    public render() {
        const viewModel = this.props.viewModel;

        return (
            <div>
                <Neo.GridLayout lg={3}>
                    <Neo.FormGroupInline bind={viewModel.meta.fromDate} dateProps={{ onDateSelected: () => viewModel.fetchNotices()}} />
                </Neo.GridLayout>
                
                {viewModel.notices.length > 0 &&
                    <NeoGrid.Grid items={viewModel.notices}>
                        {(item, meta) => (
                            <NeoGrid.Row>
                                <NeoGrid.Column display={meta.createdOn}>
                                    <div className="text-muted">
                                        {item.lookup.createdBy}
                                    </div>
                                </NeoGrid.Column>
                                <NeoGrid.Column display={meta.type} />
                                <NeoGrid.Column display={meta.noticeDate} headerTooltip="Date of last client authorisation" />
                                <NeoGrid.Column bindContext={meta.effectiveDate} headerTooltip="Date at which the transaction will be effective">
                                    {item.lookup.shareTransactionDate && !item.isCancellation && 
                                        <>
                                            <div className="text-muted">{DateUtils.format(item.lookup.shareTransactionDate)}</div>
                                            <span className="me-2"><Neo.Icon name="arrow-right" /></span>
                                        </>}
                                    {DateUtils.format(item.effectiveDate!)}
                                </NeoGrid.Column>
                                <NeoGrid.Column display={meta.amount} />
                                <NeoGrid.Column display={meta.status} className="text-center" />
                                <NeoGrid.Column display={item.lookup.meta.actionedBy} />
                                {viewModel.notices.some(c => c.canAction) && 
                                    <NeoGrid.ButtonColumn>
                                        {item.canAction &&
                                            <Neo.Button isOutline menuAlignment="right" menuItems={[
                                                { text: "Process", subText: "Process the request", onClick: () => viewModel.actionNotice(item, ActionType.Process) },
                                                { text: "Mark Complete", subText: "Mark the request as manually completed", onClick: () => viewModel.actionNotice(item, ActionType.MarkComplete) },
                                                { text: "Cancel", subText: "Cancel the request", onClick: () => viewModel.actionNotice(item, ActionType.Cancel) }
                                            ]}>Actions</Neo.Button>}
                                    </NeoGrid.ButtonColumn>}
                                {viewModel.notices.some(c => c.canAuthorise) &&
                                    <NeoGrid.ButtonColumn>
                                        {item.canAuthorise &&
                                            <Neo.Button variant="success" icon="thumbs-up" tooltip="Authorise" 
                                                onClick={() => viewModel.authoriseNotice(item)} />}
                                    </NeoGrid.ButtonColumn>}
                            </NeoGrid.Row>
                        )}
                    </NeoGrid.Grid>}
                {viewModel.notices.length === 0 && !viewModel.taskRunner.isBusy &&
                    <Neo.Alert variant="info" className="mb-0">No notices found</Neo.Alert>}
            </div>
        );
    }
}